'use client'

import { cva } from 'class-variance-authority'
import { cn } from '~/core/ui/utils'

const dotVariants = cva('rounded-full inline-block', {
  variants: {
    size: {
      xl: 'w-2 h-2',
      lg: 'w-1.5 h-1.5',
      sm: 'w-1.5 h-1.5',
      md: 'w-1.5 h-1.5'
    },
    color: {
      green: 'bg-green-500',
      pastelGreen: 'bg-green-500',
      purple: 'bg-purple-500',
      yellow: 'bg-yellow-500',
      orange: 'bg-orange-500',
      red: 'bg-red-500',
      blue: 'bg-blue-500',
      'dark-blue': 'bg-blue-1100',
      gray: 'bg-gray-400',
      white: 'bg-white',
      'chart-sourced': 'bg-blue-500',
      'chart-applied': 'bg-purple-500',
      'chart-screening': 'bg-red-400',
      'chart-client-submission': 'bg-orange-500',
      'chart-clientSubmission': 'bg-orange-500',
      'chart-interview': 'bg-yellow-500',
      'chart-offer': 'bg-pastelGreen-500',
      'chart-hired': 'bg-green-500',
      'chart-onboard': 'bg-green-500',
      'chart-probation': 'bg-green-500',
      'matched-rank-s': '',
      'matched-rank-a': '',
      'matched-rank-b': '',
      'matched-rank-c': ''
    }
  },
  defaultVariants: {
    size: 'lg',
    color: 'gray'
  }
})

type IDotColorProps =
  | 'green'
  | 'pastelGreen'
  | 'purple'
  | 'yellow'
  | 'orange'
  | 'red'
  | 'blue'
  | 'gray'
  | 'white'
  | 'chart-sourced'
  | 'chart-applied'
  | 'chart-screening'
  | 'chart-client-submission'
  | 'chart-clientSubmission'
  | 'chart-interview'
  | 'chart-offer'
  | 'chart-hired'
  | 'chart-onboard'
  | 'chart-probation'
  | 'matched-rank-s'
  | 'matched-rank-a'
  | 'matched-rank-b'
  | 'matched-rank-c'

interface DotProps {
  color?: IDotColorProps
  size?: 'sm' | 'lg' | 'xl' | 'md'
  className?: string
}

const Dot = ({ size = 'lg', color = 'gray', className = '' }: DotProps) => {
  return <span className={cn(dotVariants({ color, size, className }))} />
}

export { Dot }
export type { DotProps, IDotColorProps }

